import React, { useEffect } from 'react';
import MaterialTable, { MaterialTableProps } from 'material-table';
import { Button, Typography } from '@material-ui/core';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { useStudentPerspective, Student} from '../../../context/StudentPerspective';
import AdminLayout from '../../../layouts/AdminLayout';

const Students = (props: RouteComponentProps) => {
  const {
    loadData,
    isLoading,
    errorMessage,
    students
  } = useStudentPerspective();

  const tableProps: MaterialTableProps<Student> = {
    title: <Typography variant="h5">Students</Typography>,
    data: students,
    isLoading,
    columns: [
      {
        title: 'Student ID',
        field: 'studentID'
      },
      {
        title: 'Name',
        field: 'fullName',
        defaultSort: 'asc'
      }
    ],
    localization: {
      body: {
        emptyDataSourceMessage: 'No Student/s Found.'
      }
    },
    options: {
      headerStyle: {
        fontWeight: 'bold'
      },
      pageSize: 10,
      pageSizeOptions: [5, 10, 20, 50],
      emptyRowsWhenPaging: false,
      search: true,
      sorting: true,
      draggable: false,
      thirdSortClick: false
    },
    onRowClick: (event, student) => {
      if (student)
        props.history.push(`/admin/students/${student.studentID}/courses`);
    }
  };

  useEffect(() => {
    (async () => await loadData())();
  }, []);

  return (
    <AdminLayout>
      <div className="p-4">
        {(() => {
          if (errorMessage)
            return (
              <div className="text-center">
                <h2 className="m-0">Error Loading Students</h2>
                <p>{errorMessage}</p>
                <Button
                  type="button"
                  onClick={loadData}
                  color="primary"
                  className="mt-3"
                  variant="contained">
                  Try Again
                </Button>
              </div>
            );

          return (<MaterialTable {...tableProps} />);
        })()}
      </div>
    </AdminLayout>
  );
};

export default withRouter(Students);
